import "./EnhancedDropDown.css"

import { Box, FormHelperText } from "@mui/material";
import {
  IEnhancedDropDown,
  IEnhancedDropDownItem,
} from "./EnhancedDropDown.types";
import Select, { GroupBase, OptionProps, components } from "react-select";

import { JSX } from "react/jsx-runtime";
import React from "react";

const color = "#0057db";

const customStyles = {
  control: (provided: any, state: { isDisabled: any; }) => {
    return ({
      ...provided,
      backgroundColor: state.isDisabled ? 'rgba(0, 0, 0, 0.06)' : '#fff',
      // borderColor: '#c3c4c4',
      borderColor: (state as any).selectProps?.error ? '#d32f2f' : '#c3c4c4',
      minHeight: '3em',
      borderRadius: "2px !important",
      // height: '3em',
      // boxShadow: state.isFocused ? null : null,
      ":hover": {
        borderColor: '#000'
        //  borderColor: (state as any).selectProps?.error ? '#d32f2f' : '#000'
      },
    })
  },
  container: (provided: any) => ({
    ...provided,
    fontFamily: ["Roboto", "sans-serif"].join(","),
    fontSize: ".8125rem",
    fontWeight: 500,
    lineHeight: "1rem",
  }),
  multiValue: (styles: any) => {
    return {
      ...styles,
      backgroundColor: "#deebff",
    };
  },
  multiValueLabel: (styles: any) => ({
    ...styles,
    color: color,
    fontSize: "16px",
  }),
  multiValueRemove: (styles: any) => ({
    ...styles,
    color: color,
    ":hover": {
      backgroundColor: "#d8e6fb",
      color: color,
    },
  }),
  groupHeading: (styles: any) => ({
    ...styles,
    color: "#000",
    fontFamily: ["Roboto", "sans-serif"].join(","),
    fontWeight: 700,
    fontSize: ".8125rem",
    textTransform: "capitalize",
  }),
};

const Option = (props: JSX.IntrinsicAttributes & OptionProps<unknown, boolean, GroupBase<unknown>> | any) => {
  return (
    <div>
      <components.Option {...props}>
        {props.label !== "--" && (
          <>
            <input
              type="checkbox"
              checked={props.isSelected}
              onChange={() => null}
              style={{ accentColor: "#0057db" }}
            />{" "}
          </>
        )}
        <label>{props.label}</label>
      </components.Option>
    </div>
  );
};

/**
 * Select Input control for ReactJS with multiselect,
 * autocomplete, async and creatable support.
 */
export const EnhancedDropDown: React.FC<IEnhancedDropDown | any> = ({
  selectName,
  items,
  selectedItem,
  showEmpty,
  isClearable,
  isSearchable,
  isMulti,
  isLoading,
  isDisabled,
  isHide,
  onChangeHandler,
  testId,
  helperText,
  error,
  ref
}) => {

  const selectRef = React.useRef<any>(null);
  const wrapperRef = React.useRef<HTMLDivElement>(null);

  React.useImperativeHandle(ref, () => ({
    focus: () => selectRef.current?.focus(),
    scrollIntoView: (opts?: ScrollIntoViewOptions) =>
      wrapperRef.current?.scrollIntoView(opts ?? { behavior: "smooth", block: "center" }),
  }));


  // const classes = useStyles();
  const getItems = (
    options: IEnhancedDropDownItem[],
    isEmpty?: Boolean,
    multiEnable?: Boolean
  ) => {
    if (
      isEmpty &&
      options &&
      options.length > 0 &&
      options[0].value !== "" &&
      !multiEnable
    ) {
      let emptyOption = { value: "", label: "--" };
      options.splice(0, 0, emptyOption);
    }
    options.map((item, index) => ({
      index: item.value,
      value: {
        ...item,
        toString: () => index, // assumes item has a unique id property
      },
      label: item.label,
    }));
    return options;
  };

  const getMultiSelected = (options: IEnhancedDropDownItem[] | any) => {
    let arr: IEnhancedDropDownItem[] = [];
    options.forEach((option: any) => {
      for (let i in selectedItem) {
        if (option && option.value === selectedItem[i]) {
          arr.push(option);
        }
      }
    });
    return arr;
  };

  /**
   * this returns the value of the select input by:
   *
   * 1. If there is a selected value, it will return its option.
   * 2. If there is no selected value (undefined) e.g. when we
   *    reset the form, it will be empty string which reflects in
   *    the UI instead of undefined.
   *
   * @param {IEnhancedDropDownItem[]} options
   * @returns {IEnhancedDropDownItem | string}
   */
  // const getSingleSelectValue = (
  //   options: IEnhancedDropDownItem[]
  // ): IEnhancedDropDownItem | string | any => {
  //   if (selectedItem === undefined || selectedItem === null) return null;
  //   if (selectedItem.length === 0) return "";

  //   return options.find((option) => {
  //     return option && option.value === selectedItem;
  //   });
  // };

  const getSingleSelectValue = (
    options: IEnhancedDropDownItem[]
  ): IEnhancedDropDownItem | string | any => {
    if (selectedItem === undefined || selectedItem === null) return null;
    if (selectedItem.length === 0) return "";

    for (const option of options) {
      if (option && option.value === selectedItem) {
        return option;
      }
      if (option && (option as any).options) {
        const found = (option as any).options.find(
          (opt: any) => opt && opt.value === selectedItem
        );
        if (found) return found;
      }
    }

    return undefined;
  };

  const renderDDL = () => {
    return (
      <>
        {isHide ? null : (
          <Box className="dropDownWrapper">
            <Select
              key={selectName}
              ref={selectRef}
              options={getItems(items, showEmpty, isMulti)}
              value={
                isMulti ? getMultiSelected(items) : getSingleSelectValue(items)
              }
              components={
                isMulti
                  ? {
                    Option,
                    IndicatorSeparator: () => null,
                  }
                  : {
                    IndicatorSeparator: () => null,
                  }
              }
              hideSelectedOptions={false}
              isClearable={isClearable}
              isSearchable={isSearchable}
              // inputId={testId}
              inputId={selectName}
              name={selectName}
              isMulti={isMulti}
              isLoading={isLoading}
              isDisabled={isDisabled}
              onChange={onChangeHandler}
              // allowSelectAll={true}
              styles={customStyles}
              // error={!!error}
              // {...({ error: !!error } as any)}
              closeMenuOnSelect={!isMulti}
              classNamePrefix="dropDownField"
            />
            <FormHelperText
              sx={{
                margin: "4px 14px 0 0px",
              }}
              error
              role="alert"
            >
              {helperText}
            </FormHelperText>
          </Box>
        )}
      </>
    );
  };

  return renderDDL();
};
